
import { debounce } from '@/util/common';
export default {
  data () {
    return {
      autoTableHeight: 500,
      pageConfig: {
        current: 1,
        size: 10
      },
      formSize: 'small',
      selectedRows: []
    }
  },

  methods: {
    getTableHeight(vieport, $el, calcHeight = 150) {
      console.log(vieport, $el, calcHeight)
      return vieport - $el.offsetTop - calcHeight;
    },
    handleSearch() {
      this.pageConfig.current = 1;
      this.getList();
    },
    handlePageChange(page, size) {
      this.pageConfig.current = page;
      this.pageConfig.size = size;
      this.getList();
    },
    // 选择数据
    handleSelect(selection) {
      this.selectedRows = selection;
    },
    getSizeSync() {
      this.$nextTick(() => {
        try {
          const $el = this.$refs.eltable.$el;
          console.log(this.$refs.eltable.$el, window.innerHeight)
          this.autoTableHeight = this.getTableHeight(this.viewportSize, $el);
          console.log('autoTableHeight', this.autoTableHeight);
        } catch(err) {
          this.autoTableHeight = 500
        }
      })
    }
  },
  mounted() {
    this.handleResize = debounce(this.getSizeSync, 500);
    window.addEventListener('resize', this.handleResize);
    this.getSizeSync();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}